import { http } from "./client";

export const fetchScreening = (ApplicationID) => http.get('Applications/Screening',{params: {ApplicationID}});
export const upsertScreening = (payload) => http.post('Applications/Screening/upsert',payload);